import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthService from "../../Helpers/Auth.service";
import JWTService from "../../Helpers/JWT.service";
import api from './../../Interceptors/Interceptor';
import axios from "axios";
import VariantPriceSection from "./VariantPriceSection";
import { useDispatch, useSelector } from "react-redux";
import { homeActions } from "../../store/slice/home-slice";


const ProductSections = ({
  totalQuantity,
  setTotalQuantity,
  AddSingleToCart,
  mrp,
}) => {

  const navigate = useNavigate();
  // const [urltxt, seturltxt] = useState(
  //   `${process.env.REACT_APP_API_BASE_URL}/api/app/Products/LoadProductByCategory/2`
  // );
  // const [urlbrand, seturlbrand] = useState(
  //   `${process.env.REACT_APP_API_BASE_URL}/api/app/Products/LoadProductByCategory/2`
  // );
  // const [review, setreview] = useState([]);
  // const [selectedVariant, setSelectedVariant] = useState({});
  // const [productsVariants, setProductsVariants] = useState([]);
  // const [TotalProducts, setTotalProducts] = useState();

  // const [hotProduct, setHotProducts] = useState([]);

  const dispatch = useDispatch();
  const hotProduct = useSelector(data => data.home.hotProductList);


  useEffect(() => {
    setTimeout(() => {
      // window.scrollTo(0, 0);
    }, 100);
  }, []);


  useEffect(() => {
    const source = axios.CancelToken.source();
    console.log({ history: window.history });
    // const unlisten = navigate.listen((location, action) => {
    //   if (action === 'POP') {
    //     // User navigated using back/forward buttons
    //     console.log("Came Back");
    //   } else {
    //     // Other navigation actions (e.g., push, replace)
    //     console.log("Came Back False");
    //   }
    // });


    async function hotproductsasy() {
      try {
        const response = await api.get('/api/app/Products/LoadProductsByPriorityTag', { cancelToken: source.token });
        const data = response.data;
        // setHotProducts(data);
        dispatch(homeActions.setHotProductList(data))
        // setTotalProducts(data.length);

        // const allProductsVariants = data.flatMap(
        //   (item) => item.productVariants
        // );
        // setProductsVariants(allProductsVariants);
      } catch (error) {
        console.error("Error fetching hot products:", error);
      }
    }



    hotproductsasy();

    return () => {
      source.cancel("Unmounting ");
      // unlisten(); // Clean up the listener

    }
  }, [dispatch]);

  const productOnClick = (id) => {
    navigate(`/product-detail?id=${id}`);
  }



  async function AddSingleToCart(e, id) {
    const productsId = id;
    let usersId = localStorage.getItem('userid');
    let token = localStorage.getItem('token');

    if (token == null) {
      navigate('/login');
      return;
    }

    var requestOptions = {
      method: 'GET',
      headers: AuthService.getHeadersWithAuthToken(),
    };

    if (JWTService.isTokenExpired(token, 30)) {
      await new AuthService().refreshAccessToken();
      token = localStorage.getItem('token');
    }

    try {
      const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/api/app/Products/${productsId}`, requestOptions);
      const data = response.data;
      const Pname = data.name;
      const Pprice = data.price;

      const raw = JSON.stringify({
        "productsId": productsId,
        "usersId": usersId,
        "productVariantsId": 0,
        "productVariantPriceId": 0,
        "packing": "packaging",
        "price": Pprice,
        "qty": 1,
      });
      console.log("Request Payload:", raw);

      const requestOptions2 = {
        method: 'POST',
        headers: AuthService.getHeadersWithAuthToken(),
        data: raw,
      };

      const response4 = await api.post(`${process.env.REACT_APP_API_BASE_URL}/api/app/Carts`, raw, requestOptions2);

      if (response4.status === 200 || response4.status === 201) {
        toast.success(`${Pname} added to cart!`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTotalQuantity(totalQuantity + 1);
        return 0;
      } else {
        toast.error('Cannot Add Product In Cart..LogIn', {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        navigate('/login');
        return;
      }
    } catch (error) {
      console.error(error);
      // Handle error as needed
    }
  }




  async function AddVariantToCart(e) {
    let usersId = localStorage.getItem("userid");
  }



  return (
    <div>
      <ToastContainer theme="dark" />
      {/* <section className="banners mb-25">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div
                className="banner-img wow animate__animated animate__fadeInUp"
                data-wow-delay={0}
              >
                <img src="assets/imgs/banner/banner-1.png" alt="banner-img" />
                <div className="banner-text">
                  <h4>
                    Everyday Fresh &amp; <br />
                    Clean with Our
                    <br />
                    Products
                  </h4>
                  <a href="./shop" className="btn btn-xs">
                    Shop Now <i className="fi-rs-arrow-small-right" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="banner-img wow animate__animated animate__fadeInUp"
                data-wow-delay=".2s"
              >
                <img src="assets/imgs/banner/banner-2.png" alt="banner-img" />
                <div className="banner-text">
                  <h4>
                    Make your Breakfast
                    <br />
                    Healthy and Easy
                  </h4>
                  <a href="./shop" className="btn btn-xs">
                    Shop Now <i className="fi-rs-arrow-small-right" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 d-md-none d-lg-flex">
              <div
                className="banner-img mb-sm-0 wow animate__animated animate__fadeInUp"
                data-wow-delay=".4s"
              >
                <img src="assets/imgs/banner/banner-3.png" alt="banner-img" />
                <div className="banner-text">
                  <h4>
                    The best Organic <br />
                    Products Online
                  </h4>
                  <a href="./shop" className="btn btn-xs">
                    Shop Now <i className="fi-rs-arrow-small-right" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/*End banners*/}

      <section className="product-tabs section-padding position-relative" style={{
        minHeight: 992
      }}>
        <div className="container">
          <div className="section-title style-2 wow animate__animated animate__fadeIn">
            <h3>Popular Products</h3>
          </div>
          {/*End nav-tabs*/}
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="tab-one"
              role="tabpanel"
              aria-labelledby="tab-one"
            >
              <div className="row product-grid-4">
                {hotProduct && hotProduct?.map(({ id, price, name, shortCode,
                  shortName, stars, mrp, type, productVariants, productImages,
                  brandName,
                  brandId,
                }) => (
                  <div
                    className="col-lg-3 col-xl-2 col-md-4 col-6 col-sm-6"
                    key={id}
                  >
                    <div
                      className="product-cart-wrap mb-30 wow animate__animated animate__fadeIn"
                      data-wow-delay=".1s"
                      style={{
                        width: "100%!important",

                      }}
                    >
                      <div className="product- img-action-wrap">
                        {/* <div className="product-img product-img-zoom"> */}
                        <a onClick={(e) => {
                          e.stopPropagation();
                          productOnClick(id, e);
                        }}

                          className=" d-flex  justify-content-center pt-2"
                        >
                          {productImages.length === 0 ? (
                            <img
                              className="default-img"
                              src="assets/imgs/shop/grocery.png"
                              alt={name}
                              style={{ height: 180, width: 180 }}
                            />
                          ) : (

                            < img
                              src={productImages[0]?.imageUrl}
                              className="default-img"
                              alt={name}
                              style={{
                                height: 180,
                                width: "auto",
                                // opacity: loading ? 0.5 : 1
                                transition: "ease-in  3s"
                              }}
                            />

                          )}
                        </a>
                        {/* </div> */}

                        <div className="product-badges product-badges-position product-badges-mrg">
                          <span className="hot">Hot</span>
                        </div>
                      </div>
                      <div className="product-content-wrap">
                        <div className="product-category">
                          <NavLink
                            to={`/product-detail?id=${id}`}
                          >
                          </NavLink>
                        </div>

                        <h2 style={{
                          minHeight: "57px",
                          maxHeight: "57px",
                          overflow: "hidden"
                        }}>
                          <NavLink to={`/product-detail?id=${id}`}>
                            {/*  onClick={(e) => { singleproduct(item.id) }} href="product" */}
                            {name}
                          </NavLink>
                        </h2>


                        <div>
                          <span className="font-small text-muted">
                            By{" "}
                            <a
                              // to={`/product- detail?id=${id}`}
                              // to={"/shop"}
                              href="/shop"
                              onClick={e => {
                                e.stopPropagation();
                                const params = { type: "brand", id: brandId };
                                console.log(params);
                                navigate("/shop", { state: params });
                              }}
                            >
                              {brandName}
                            </a>
                          </span>
                        </div>
                        {type === "normal" ? (
                          <>
                            <div className="product-price">
                              <span>&#8377; {price}</span>
                              {parseFloat(mrp) !== 0 && mrp !== price && <span className="old-price">&#8377; {mrp}</span>}
                            </div>

                            <div className="product-card-bottom">
                              <div className="qty-select">
                                <div className="add-cart">
                                  <a
                                    className="add"
                                    onClick={(e) => AddSingleToCart(e, id)}
                                  >
                                    <i className="fi-rs-productping-cart mr-5" />
                                    Add to cart
                                  </a>
                                </div>
                              </div>
                            </div>

                          </>
                        ) : (
                          <>

                            {productVariants.length > 0 &&
                              <VariantPriceSection
                                price={price}
                                mrp={mrp}
                                totalQuantity={totalQuantity}
                                setTotalQuantity={setTotalQuantity}
                                productId={id}
                                productVariants={productVariants} />
                            }

                          </>
                        )}

                      </div>
                    </div>
                  </div>
                )
                )}
              </div>
              {/*End product-grid-4*/}
            </div>
            {/*En tab one*/}
            <div
              className="tab-pane fade"
              id="tab-two"
              role="tabpanel"
              aria-labelledby="tab-two"
            >
              <div className="row product-grid-4"></div>
              {/*End product-grid-4*/}
            </div>
            {/*En tab two*/}
            <div
              className="tab-pane fade"
              id="tab-three"
              role="tabpanel"
              aria-labelledby="tab-three"
            >
              <div className="row product-grid-4"></div>
              {/*End product-grid-4*/}
            </div>
            {/*En tab three*/}
            <div
              className="tab-pane fade"
              id="tab-four"
              role="tabpanel"
              aria-labelledby="tab-four"
            >
              <div className="row product-grid-4"></div>
              {/*End product-grid-4*/}
            </div>
            {/*En tab four*/}
            <div
              className="tab-pane fade"
              id="tab-five"
              role="tabpanel"
              aria-labelledby="tab-five"
            >
              <div className="row product-grid-4"></div>
              {/*End product-grid-4*/}
            </div>
            {/*En tab five*/}
            <div
              className="tab-pane fade"
              id="tab-six"
              role="tabpanel"
              aria-labelledby="tab-six"
            >
              <div className="row product-grid-4"></div>
              {/*End product-grid-4*/}
            </div>
            {/*En tab six*/}
            <div
              className="tab-pane fade"
              id="tab-seven"
              role="tabpanel"
              aria-labelledby="tab-seven"
            >
              <div className="row product-grid-4"></div>
              {/*End product-grid-4*/}
            </div>
            {/*En tab seven*/}
          </div>
          {/*End tab-content*/}
        </div>
      </section >
    </div >
  );
};

export default ProductSections;
